import React from 'react';
import { RCIcon } from '@reverbdotcom/cadence/components';
import { ClockCounterClockwiseIcon } from '@phosphor-icons/react';

import { Listing, NextBestAction } from '@reverbdotcom/commons/src/gql/graphql';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { RCTextUtility } from '@reverbdotcom/cadence/components/RCText/RCText';

import { Insight, trackClicked, trackFollowed, useTrackingContext, useTrackImpression } from './sellerRecommendationTracking';
import RenewListingButton from '../listings/RenewListingButton';

interface Props {
  listing: Listing;
  nextBestAction: NextBestAction;
  insight: Insight;
}

export const COMPONENT_NAME = 'RenewListingPresentment';

export default function RenewListingPresentment({ listing, nextBestAction, insight }: Props) {
  const trackingContext = useTrackingContext();
  useTrackImpression(COMPONENT_NAME, insight, listing.id);

  return (
    <>
      <div className="seller-listing-insight-presentment">
        <span className="seller-listing-insight-presentment__renew-eligible">
          <RCIcon icon={<ClockCounterClockwiseIcon weight="duotone" />} size="inline-prominent" spacing="right" color="accent-loud" />
          <RCTextUtility size="350">
            <SanitizedRender html={nextBestAction.title ?? ''} />
          </RCTextUtility>
        </span>
        {!!nextBestAction.subtitle && (
          <RCTextUtility size="350">
            <SanitizedRender html={nextBestAction.subtitle} />
          </RCTextUtility>
        )}
        <RenewListingButton
          listing={listing}
          label={nextBestAction.ctaText ?? undefined}
          onClick={() => trackClicked(COMPONENT_NAME, insight, listing.id, trackingContext)}
          onRenewSuccess={(appliedPriceCents) => trackFollowed(
            COMPONENT_NAME, insight, listing.id, trackingContext, { appliedPriceCents },
          )}
        />
      </div>
    </>
  );
}
